var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 13.95H23.75V17.05H17.55V23.25H14.45V17.05H8.25V13.95H14.45V7.75H17.55V13.95ZM16 31C11.8891 31 7.94666 29.367 5.03984 26.4602C2.13303 23.5533 0.5 19.6109 0.5 15.5C0.5 11.3891 2.13303 7.44666 5.03984 4.53984C7.94666 1.63303 11.8891 0 16 0C20.1109 0 24.0533 1.63303 26.9602 4.53984C29.867 7.44666 31.5 11.3891 31.5 15.5C31.5 19.6109 29.867 23.5533 26.9602 26.4602C24.0533 29.367 20.1109 31 16 31ZM16 27.9C19.2887 27.9 22.4427 26.5936 24.7681 24.2681C27.0936 21.9427 28.4 18.7887 28.4 15.5C28.4 12.2113 27.0936 9.05733 24.7681 6.73188C22.4427 4.40642 19.2887 3.1 16 3.1C12.7113 3.1 9.55733 4.40642 7.23188 6.73188C4.90642 9.05733 3.6 12.2113 3.6 15.5C3.6 18.7887 4.90642 21.9427 7.23188 24.2681C9.55733 26.5936 12.7113 27.9 16 27.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddition);
export default __webpack_public_path__ + "static/media/addition.0e8bd5303cb5dc625066000f6fdf2bd2.svg";
export { ForwardRef as ReactComponent };